import { UtilsProvider } from "./../utils/utils";
import { Apollo } from "apollo-angular";
import { AuthProvider } from "./../auth/auth";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { deviceTypes, Task } from "../tasks/models";
import { Observable } from "rxjs";
import { ENV } from "../../environments/environment";
import { DEVICE_QUERY } from "./queries";
import { DeviceQL } from "./models";

@Injectable()
export class DevicesProvider {
  public faults: Array<{
    id: string;
    name: string;
    value: string;
    desired: boolean;
  }> = [
    {
      id: "faultOverTemperature",
      name: "Over Temperature",
      value: "faultOverTemperature",
      desired: false,
    },
    {
      id: "faultOverTemperatureExt",
      name: "Ext Temp Over Temperature",
      value: "faultOverTemperatureExt",
      desired: false,
    },
    {
      id: "faultExtTempProbeDisconnected",
      name: "Ext Temp Disconnected",
      value: "faultExtTempProbeDisconnected",
      desired: false,
    },
    {
      id: "faultIntTempProbeDisconnected",
      name: "Int Temp Disconnected",
      value: "faultIntTempProbeDisconnected",
      desired: false,
    },
    {
      id: "faultDripTrayProbeRemoved",
      name: "Drip Tray Disconnected",
      value: "faultDripTrayProbeRemoved",
      desired: false,
    },
    {
      id: "faultMainsFailure",
      name: "Mains Failure",
      value: "faultMainsFailure",
      desired: false,
    },
    {
      id: "faultBatteryFailure",
      name: "Battery Failure",
      value: "faultBatteryFailure",
      desired: false,
    },
    {
      id: "faultElementOpen",
      name: "Element Circuit Open",
      value: "faultElementOpen",
      desired: false,
    },
    {
      id: "faultElementDrawingCurrent",
      name: "Element Drawing Current",
      value: "faultElementDrawingCurrent",
      desired: false,
    },
    {
      id: "faultDripTray",
      name: "Drip Tray Water Detected",
      value: "faultDripTray",
      desired: false,
    },
    {
      id: "faultWaterValveBoth0",
      name: "Waver Valve Undecidable. Stuck?",
      value: "faultWaterValveBoth0",
      desired: false,
    },
    {
      id: "faultWaterValveBoth1",
      name: "Waver Valve Undecidable. Circuit?",
      value: "faultWaterValveBoth1",
      desired: false,
    },
    {
      id: "faultValveRemoved",
      name: "Water Valve Removed",
      value: "faultValveRemoved",
      desired: false,
    },
    {
      id: "faultValveDoesntOpen",
      name: "Water Valve Failed To Open",
      value: "faultValveDoesntOpen",
      desired: false,
    },
    {
      id: "faultValveDoesntClose",
      name: "Water Valve Failed To Close",
      value: "faultValveDoesntClose",
      desired: false,
    },
  ];
  constructor(
    public http: HttpClient,
    private authProvider: AuthProvider,
    private apollo: Apollo,
    private utils: UtilsProvider
  ) {}

  getDeviceQL(params?: { serial: string }) {
    return Observable.create((obs) => {
      this.apollo
        .query<any>({
          query: DEVICE_QUERY,
          variables: params,
        })
        .subscribe(
          (r) => {
            const deviceQL: DeviceQL = r.data.device;
            obs.next(deviceQL);
          },
          (e) => {
            this.utils.handleGraphError(e, true);
            obs.error(e);
          }
        );
    });
  }

  getDeviceInfo(serial) {
    return Observable.create((observer) => {
      let headers = new Headers();
      this.authProvider.getOptions().subscribe((options) => {
        let deviceAPI = ENV.base + "/device-shadow/devices/" + serial;
        this.http
          .get(deviceAPI, options)
          .map((response: any) => response)
          .subscribe(
            (result) => {
              const snn = result && result.active ? result.active.snn : "";
              let shadowAPI = ENV.base + "/device-shadow/shadows/" + snn;
              this.http.get(shadowAPI, options).subscribe(
                (shadowResult) => {
                  observer.next(shadowResult);
                },
                (err) => {
                  observer.error(err);
                }
              );
            },
            (err) => {
              observer.error(err);
            }
          );
      });
    });
  }

  resetDevice(serial: string) {
    this.authProvider.getOptions().subscribe((options) => {
      const deviceAPI = ENV.base + "/device-shadow/devices/" + serial;
      this.http
        .get(deviceAPI, options)
        .map((response: any) => response)
        .subscribe((result) => {
          const snn = result && result.active ? result.active.snn : "";
          const resetApi = ENV.base + "/device-shadow/reset-device/" + snn;
          this.http
            .post(resetApi, null, options)
            .map((response: any) => response)
            .subscribe((result) => {
            });
        });
    });
  }

  startTest(serial, task) {
    return Observable.create((observer) => {
      let obj = {
        taskId: task.id,
        status: task.status,
      };
      this.authProvider.getOptions().subscribe((options) => {
        let api = ENV.api + "/api/geyser/" + serial + "/test"; ///geyser/{serial}/test
        this.http.put(api, obj, options).subscribe(
          (result) => {
            observer.next(result);
          },
          (err) => {
            observer.error(err);
          }
        );
      });
    });
  }

  getTest(serial) {
    return Observable.create((observer) => {
      this.authProvider.getOptions().subscribe((options) => {
        let api = ENV.api + "/api/geyser/" + serial + "/test"; ///geyser/{serial}/test
        this.http.get(api, options).subscribe(
          (result) => {
            observer.next(result);
          },
          (err) => {
            observer.error("error");
          }
        );
      });
    });
  }

  getDeviceTypeLabel(val: Task.DeviceTypeEnum) {
    const selType = deviceTypes.filter((type) => {
      return type.value === val;
    })[0];
    return selType ? selType.label : "Unknown";
  }

  getSerial(qrcode: string) {
    if (!qrcode) return;
    // for old barcode scanning
    let serial = qrcode.trim();

    return serial;
  }

  qrCodeToSerial(qrcode: string): string {
    let serial = "";
    // Backwards compatability for GEYSER qrcodes:

    serial = qrcode
      .trim()
      .replace(/snsecdev:|sngeyser:|sncongey:|snfirealarm:/gi, function (str) {
        return "";
      });

    if (qrcode.indexOf("sngeyser:") >= 0 && serial.indexOf("GEYSER") < 0) {
      serial += "GEYSER";
    } else if (qrcode.indexOf("sncongey:") >= 0 && serial.indexOf("CONGEY") < 0 && !serial.includes("GEYSER")) {
      serial += "CONGEY";
    }
    return serial;
  }

  qrCodeParseValidated(qrcode: string, type: Task.DeviceTypeEnum, isReplacementDevice?: boolean) {
    return Observable.create((observer) => {
      let flag = false;
      if (isReplacementDevice) {
        if (
          (type === Task.DeviceTypeEnum.Geyser || type === Task.DeviceTypeEnum.Congey) && // Is GEYSER or CONGEY
          (qrcode.indexOf("sngeyser:") === 0  || qrcode.indexOf("sncongey:") === 0) &&  // starts with sngeyser: or sncongey:
          (qrcode.includes("CONGEY") || qrcode.includes("GEYSER")) // includes CONGEY or GEYSER
        ) { flag = true; }

        if (flag) {
          observer.next(this.qrCodeToSerial(qrcode));
        } else {
          const msg = "Replacement device is not a geyser: " + type.toLowerCase();
          observer.error(msg);
        }
      }
      else {

        if (
          type === Task.DeviceTypeEnum.Geyser &&
          qrcode.indexOf("sngeyser:") === 0 &&
          qrcode.includes("GEYSER")
        ) {
          flag = true;
        } else if (
          type === Task.DeviceTypeEnum.Congey &&
          qrcode.includes("CONGEY")
        ) {
          flag = true;
        } else if (
          type === Task.DeviceTypeEnum.FireAlarm &&
          (qrcode.indexOf("snfirealarm:") === 0 || qrcode.includes("FIREAL1"))
        ) {
          flag = true;
        } else if (
          type === Task.DeviceTypeEnum.FireAlarm &&
          (qrcode.indexOf("snfirealarm:") === 0 || qrcode.includes("FIRE"))
        ) {
          qrcode = qrcode.substring(0, qrcode.indexOf(";"));
          flag = true;
        } else if (
          type === Task.DeviceTypeEnum.Security &&
          qrcode.indexOf("snsecdev:") === 0 &&
          qrcode.includes("SECDEV")
        ) {
          flag = true;
        } else if (
          type === Task.DeviceTypeEnum.Congey &&
          qrcode.indexOf("sncongey:") === 0 &&
          qrcode.includes("CONGEY")
        ) {
          flag = true;
        } 
        if (flag) {
          observer.next(this.qrCodeToSerial(qrcode));
        } else {
          const msg =
            "QR Code does not match for task of type " + type.toLowerCase();
          observer.error(msg);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/devices/devices.ts